import React from 'react';
import { useTerminalConfigStore } from '../../store/terminalConfigStore';
import { useTerminalExtStore } from '../../store/terminalExtStore';
import ProfileInstallHint from './ProfileInstallHint';
import { notFoundProgram } from './terminalProfiles';

/**
 * A pane whose program is not installed shows the install hint in place of
 * a dead terminal. Re-check asks Rust again; if the program is there now,
 * the pane restarts by itself.
 */
export default function PaneMissingProgram({ pane }) {
  const program = notFoundProgram(pane.error);
  const profile = useTerminalConfigStore((s) => s.profiles.find((p) => p.id === pane.profileId));
  const detecting = useTerminalConfigStore((s) => s.detecting);
  if (!program) return null;
  const shown = profile || { name: pane.label || program, command: program, install: null };
  const recheck = async () => {
    const cfg = useTerminalConfigStore.getState();
    await cfg.detect(true);
    if (useTerminalConfigStore.getState().detection[program]) {
      useTerminalExtStore.getState().restartPane(pane.id);
    }
  };
  return <ProfileInstallHint profile={shown} variant="pane" rechecking={detecting} onRecheck={recheck} />;
}
